<button class="font-bold" [ngClass]="className">
  <ng-content></ng-content>
</button>
